import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import TextInput from '../../../Shared/TextInput';
import SelectInput from '../../../Shared/SelectInput';
import LoadingButton from '../../../Shared/LoadingButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can } from '../../../utils';
import * as moment from 'moment';

const Index = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [openSearch, setOpenSearch] = useState(false);
     const [values, setValues] = useState({
          status: '',
          origin: '',
          from_date: '',
          to_date: '',
          posted: '',
          paging: ''
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function toggleSearch(e) {
          e.preventDefault();
          setOpenSearch(!openSearch);
     }

     function handleSearch(e) {
          e.preventDefault();
          // setSending(true);
          console.log(values);
          Inertia.post(route('report.sales.filter'), values).then(() => {
               setSending(false);
          });
     }

     function handlePost(e, id) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('order.posted', id)).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Sales Report</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Sales Report</span>
               </div>
               {!data.orders.data && (<div className="rounded col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">No sales yet :(</div>)}
               {data.orders.data && (<DataContainer>
                    <div className="col-span-12">
                         <InertiaLink onClick={e=>toggleSearch(e)} href={route('')} className="bg-gray-300 hover:bg-gray-400 mr-2 text-gray-800 text-sm py-1 px-1 rounded inline-flex items-center">
                              <Icon name={'search'} className={'fill-current w-4 h-4 mr-2'} />
                              Search
                         </InertiaLink>
                         <InertiaLink href={route('report.sales')} className={`text-gray-500 hover:underline text-sm inline-flex items-center`}>
                              Clear
                         </InertiaLink>
                    </div>
                    <div className={`col-span-12 border p-2 rounded bg-gray-100 ${openSearch?'block':'hidden'}`}>
                         <h2 className="text-md font-semibold text-gray-700">Search</h2>
                         <form className="w-full" onSubmit={handleSearch}>
                              <div className="grid grid-cols-3 gap-2">
                                   <TextInput
                                        className="form-input rounded-md shadow-sm block"
                                        label="From Date"
                                        name="from_date"
                                        type="date"
                                        disable={false}
                                        readonly={false}
                                        must={false}
                                        errors={errors.from_date}
                                        value={values.from_date}
                                        onChange={handleChange}
                                   />
                                   <TextInput
                                        className="form-input rounded-md shadow-sm block"
                                        label="To Date"
                                        name="to_date"
                                        type="date"
                                        disable={false}
                                        readonly={false}
                                        must={false}
                                        errors={errors.to_date}
                                        value={values.to_date}
                                        onChange={handleChange}
                                   />
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Status"
                                        name="status"
                                        must={false}
                                        errors={errors.status}
                                        value={values.status}
                                        onChange={handleChange}
                                   >
                                        <option value="">Search By</option>
                                        {data.statuses.map((status, i)=>{
                                             return <option key={`stat${i}`} value={status.id}>{status.name}</option>
                                        })}
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Origin"
                                        name="origin"
                                        must={false}
                                        errors={errors.origin}
                                        value={values.origin}
                                        onChange={handleChange}
                                   >
                                        <option value="">Origin</option>
                                        {data.origins.map((origin, i)=>{
                                             return <option key={`ordby${i}`} value={origin}>{origin}</option>
                                        })}
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Quanity per Page"
                                        name="paging"
                                        must={false}
                                        errors={errors.paging}
                                        value={values.paging}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Quantity per Page</option>
                                        {data.paginates.map((page, i)=>{
                                             return <option key={`pp${page}`} value={page}>{page}</option>
                                        })}
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Posted"
                                        name="posted"
                                        must={false}
                                        errors={errors.posted}
                                        value={values.posted}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Posted or Not</option>
                                        <option value={'posted'}>Posted</option>
                                        <option value={'notposted'}>Not Posted</option>
                                   </SelectInput>
                                   <div className="inline-block relative">
                                        <LoadingButton type="submit" loading={sending} className="w-full mt-5 text-center items-center px-4 py-3 bg-gray-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring-gray disabled:opacity-25 transition ease-in-out duration-150">
                                             Search
                                        </LoadingButton>
                                   </div>
                              </div>
                         </form>
                    </div>
                    <table className="table-fixed col-span-12 text-sm">
                         <thead className="bg-gray-200">
                              <tr>
                                   <th className="px-4 py-2">Receipt No.</th>
                                   <th className="px-4 py-2">Reference</th>
                                   <th className="px-4 py-2">Accpac No.</th>
                                   <th className="px-4 py-2">Origin</th>
                                   <th className="px-4 py-2">Amount</th>
                                   <th className="px-4 py-2">Status</th>
                                   <th className="px-4 py-2">Date</th>
                                   <th className="px-4 py-2"></th>
                              </tr>
                         </thead>
                         <tbody>
                              {data.orders.data.map(({id, number, reference, accpac, origin, currency, amount, status, filter, color, date, can_post}) => {
                                   return <tr key={id}>
                                        <td className="border px-4 py-2 text-center">{number}</td>
                                        <td className="border px-4 py-2 text-center">{reference}</td>
                                        <td className="border px-4 py-2 text-center">{accpac}</td>
                                        <td className="border px-4 py-2 text-center">{origin}</td>
                                        <td className="border px-4 py-2 text-right">{currency} {amount.toFixed(2)}</td>
                                        <td className="border px-4 py-2 text-center font-semibold" style={{color: `#${color}`}}>{status}</td>
                                        <td className="border px-4 py-2 text-center">{moment(date).format('DD MMM YYYY')}</td>
                                        <td className="border px-4 py-2 text-center">
                                             {(can(auth.user, 'order-post') && can_post) && (<LoadingButton onClick={e=>handlePost(e, id)} type="button" loading={sending} className="w-full rounded bg-gray-300 block px-6 py-2 text-gray-600 hover:bg-gray-500 hover:text-gray-200 hover:font-semibold disabled:opacity-25 transition ease-in-out duration-150">
                                                  Post
                                             </LoadingButton>)}
                                             {(can(auth.user, 'order-unpost') && !can_post) && (<LoadingButton onClick={e=>handlePost(e, id)} type="button" loading={sending} className="w-full rounded bg-red-300 block px-6 py-2 text-red-600 hover:bg-red-500 hover:text-red-200 hover:font-semibold disabled:opacity-25 transition ease-in-out duration-150">
                                                  Unpost
                                             </LoadingButton>)}
                                        </td>
                                   </tr>
                              })}
                         </tbody>
                    </table>
                    <Pagination links={data.orders.links} />
               </DataContainer>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Index.layout = page => <AdminLayout children={page} header={'Sales Report'} />;

export default Index;
